var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBoxZzim',{attrs:{"section":_vm.section,"is-on":_vm.isOn,"toggle-fn":_vm.toggle,"title":_vm.title,"zzim-icon":_vm.zzimIcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }